import i18nFactory from '@yandex-int/i18n';
import classNames from 'classnames';
import { Tumbler } from 'lego-on-react';
import { KeyboardEvent, useCallback } from 'react';
import * as React from 'react';

import { Bem } from '../../../service/Bem/Bem';
import { TestBem } from '../../../service/TestBem';
import { KeyCode } from '../../../typings/common';
import { ButtonDecorator } from '../../ButtonDecorator/ButtonDecorator';
import { InputField, InputFieldType } from '../../InputField/InputField';

import './PhrasesSelectorManualEntry.css';
import * as keyset from './PhrasesSelectorManualEntry.i18n';

const i18n = i18nFactory(keyset);

export interface PhrasesSelectorManualEntryProps {
    isExcludePhrases: boolean;
    value: string;
    onChange: (value: string) => void;
    onSubmit: () => void;
    onExcludePhrasesToggle: () => void;
}

const BLOCK = 'phrases-selector-manual-entry';

export const PhrasesSelectorManualEntry = ({
    value,
    isExcludePhrases,
    onChange,
    onSubmit,
    onExcludePhrasesToggle
}: PhrasesSelectorManualEntryProps) => {
    const onKeydown = useCallback((event: KeyboardEvent<HTMLDivElement>) => {
        if (event.keyCode === KeyCode.RETURN) {
            onSubmit();
        }
    }, []);

    return (
        <div className={BLOCK}>
            <div className={Bem.cls(BLOCK, 'form')}>
                <InputField
                    hasClear={true}
                    size="n"
                    inputType={InputFieldType.TEXT}
                    theme="normal"
                    tone="default"
                    placeholder={i18n('placeholder')}
                    text={value}
                    cls={classNames(Bem.cls(BLOCK, 'input'), TestBem.cls(BLOCK, 'input'))}
                    onChange={onChange}
                    onKeyDown={onKeydown}
                />
                <ButtonDecorator
                    disabled={!value}
                    cls={Bem.cls(BLOCK, 'generate-button')}
                    size="n"
                    theme="normal"
                    text={i18n('add-button')}
                    onClick={onSubmit}
                />
            </div>
            <Tumbler
                cls={Bem.cls(BLOCK, 'exclude-phrases-tumbler')}
                theme="normal"
                view="default"
                size="s"
                checked={isExcludePhrases}
                onChange={onExcludePhrasesToggle}
            >
                <Tumbler.On id="exclude-phrases" side="right" text={i18n('exclude-phrases')}>
                    {i18n('exclude-phrases')}
                </Tumbler.On>
            </Tumbler>
        </div>
    );
};
